import produce from "immer";

import {
    messageComposerActionNames,
    MessageComposerActionTypes,
} from "./messageComposerActionTypes";
import { MessageComposerState } from "./messageComposerState";

export const messageComposerReducer = (
    state: MessageComposerState,
    action: MessageComposerActionTypes
): MessageComposerState =>
    produce(state, draft => {
        switch (action.type) {
            case messageComposerActionNames.CLEAR_ERROR: {
                draft.error = undefined;
                draft.errorType = undefined;
                break;
            }

            case messageComposerActionNames.CLEAR_FILE_ATTACHMENTS: {
                draft.attachments = undefined;
                break;
            }

            case messageComposerActionNames.SEND_MESSAGE: {
                draft.sendingMessage = true;
                draft.error = undefined;
                draft.errorType = undefined;
                break;
            }

            case messageComposerActionNames.SEND_MESSAGE_SUCCESS: {
                draft.sendingMessage = false;
                draft.attachments = undefined;
                draft.error = undefined;
                draft.errorType = undefined;
                break;
            }

            case messageComposerActionNames.SEND_MESSAGE_FAILURE: {
                draft.sendingMessage = false;
                draft.error = action.payload.error.friendlyMessages;
                draft.errorType = action.payload.error.type;
                break;
            }

            case messageComposerActionNames.FILE_ATTACHMENT_UPLOAD_STARTED: {
                draft.isUploadingAttachment = true;
                break;
            }

            case messageComposerActionNames.FILE_ATTACHMENT_UPLOAD_SUCCESS: {
                const updatedAtt = [...(state.attachments ?? [])];
                updatedAtt.push(action.payload.attachment);
                draft.attachments = updatedAtt;
                draft.isUploadingAttachment = false;
                break;
            }

            case messageComposerActionNames.FILE_ATTACHMENT_UPLOAD_FAILURE: {
                draft.error = action.payload.message;
                draft.errorType = "attachmentUpload";
                draft.isUploadingAttachment = false;
                break;
            }

            case messageComposerActionNames.UPDATE_FILE_ATTACHMENTS: {
                draft.attachments = action.payload.attachments;
                break;
            }

            case messageComposerActionNames.COPY_FILE_ATTACHMENTS_STARTED: {
                draft.isUploadingAttachment = true;
                draft.attachments = undefined;
                break;
            }

            case messageComposerActionNames.COPY_FILE_ATTACHMENTS_SUCCESS: {
                draft.attachments = action.payload.attachments;
                draft.isUploadingAttachment = false;
                break;
            }

            case messageComposerActionNames.COPY_FILE_ATTACHMENTS_FAILURE: {
                draft.error = action.payload.message;
                draft.errorType = action.payload.apiError.type;
                draft.isUploadingAttachment = false;
                break;
            }
        }
    });
